module.exports = __webpack_public_path__ + "uy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/uy.svg
// module id = 869
// module chunks = 0